import cx from 'clsx';
import { Button, ButtonProps } from '@vechaiui/react';

const CompoundButton: React.FC<CompoundButtonProps> = ({
  children,
  className,
  secondaryText,
  ...props
}) => {
  return (
    <Button {...props} className={cx(className, 'h-auto p-2')}>
      <div className="text-left ml-3 mr-8">
        <span className="block text-lg">{children}</span>
        <span className="block text-sm text-neutral-400">{secondaryText}</span>
      </div>
    </Button>
  );
};
export type CompoundButtonProps = ButtonProps & {
  secondaryText?: React.ReactNode;
};

export default CompoundButton;
